import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PoseService from "services/PoseService";

export const getPoses = createAsyncThunk(
  "school/getPoses",
  async (params, { rejectWithValue }) => {
    try {
      const response = await PoseService.getPoses(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const downloadPosesExcel = createAsyncThunk(
  "school/downloadPosesExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await PoseService.downalodPosesExcel(data, params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getSinglePose = createAsyncThunk(
  "school/getSinglePose",
  async (params, { rejectWithValue }) => {
    try {
      const response = await PoseService.getSinglePose(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getLatestPoseName = createAsyncThunk(
  "school/getLatestPoseName",
  async (params, { rejectWithValue }) => {
    try {
      const response = await PoseService.getLatestPoseName(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const addPose = createAsyncThunk(
  "school/addPoses",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await PoseService.addPose(data, params);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editPose = createAsyncThunk(
  "school/editPoses",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await PoseService.editPose(data, params);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editBulkPoseStatus = createAsyncThunk(
  "school/editBulkPoseStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      const response = await PoseService.editPoseStatus(data, status);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);

const poseSlice = createSlice({
  name: "poses",
  initialState: {
    poses: {},
    singlePose: {},
    loading: false,
    error: null,
    latestPoseName: "",
    selectedPoseCategory: "individual",
  },
  reducers: {
    setSelectedPoseCategory: (state, action) => {
      state.selectedPoseCategory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPoses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPoses.fulfilled, (state, action) => {
        state.loading = false;
        state.poses = action.payload;
      })
      .addCase(getPoses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadPosesExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadPosesExcel.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadPosesExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getLatestPoseName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLatestPoseName.fulfilled, (state, action) => {
        state.loading = false;
        state.latestPoseName = action.payload.new_name;
      })
      .addCase(getLatestPoseName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getSinglePose.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSinglePose.fulfilled, (state, action) => {
        state.loading = false;
        state.singlePose = action.payload;
      })
      .addCase(getSinglePose.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addPose.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPose.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addPose.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editPose.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editPose.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editPose.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editBulkPoseStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editBulkPoseStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editBulkPoseStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedPoseCategory } = poseSlice.actions;
export default poseSlice.reducer;
